<!--
 * @Author: wangjx
 * @LastEditors: xiaona.wang
 * @Date: 2021-08-09 10:45:58
 * @LastEditTime: 2021-09-06 20:03:52
 * @Description: 编辑用户权限
-->

<template>
  <el-dialog
    v-dialogDrag
    :title="`分配菜单权限(${tenantName})`"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :loading.sync="loading"
    width="60%"
    class="self-dialog-form"
    top="5vh"
  >
    <tabs v-model="activeTabName" :props-data="tabList" @tab-click="handleTabClick" />
    <div v-show="activeTabName === 'web'" class="tab_warp_pane">
      <menu-tree
        ref="webTree"
        v-loading="loading"
        hide-select-all="true"
        :tree-data="webMenuTree"
        :show-tag-types="true"
        :default-checked-keys="defaultCheckedKeys"
      />
    </div>
    <div v-show="activeTabName === 'app'" class="tab_warp_pane">
      <menu-tree
        ref="appTree"
        v-loading="loading"
        hide-select-all="true"
        :tree-data="appMenuTree"
        :show-tag-types="true"
        :default-checked-keys="defaultCheckedKeys"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading.sync="dialogLoading" @click="handleConfirm">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import MenuTree from "@/components/private/menu-tree/menu-tree.vue";
import Tabs from "@/components/common/Tabs/tabs";
import BusinessApi from "@/api/business/index";
export default {
  name: "AssignMenu",
  components: { MenuTree, Tabs },

  props: {
    visible: {
      type: Boolean,
      default: () => false
    },

    tenantId: {
      type: String,
      default: () => ""
    },
    tenantName: {
      type: String,
      default: () => ""
    },
    webMenuTree: {
      type: Array,
      default: () => []
    },
    appMenuTree: {
      type: Array,
      default: () => []
    },
    parentNodes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkedAll: false,
      indeterminate: false,
      treeData: [],
      loading: false,
      childCount: 0,
      nodeCount: 0,
      // 默认选择的菜单
      defaultCheckedKeys: [],

      activeTabName: "web",
      tabList: [
        {
          name: "web",
          label: "WEB端功能权限"
        },
        {
          name: "app",
          label: "APP端功能权限"
        }
      ]
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    dialogLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      }
    }
  },
  watch: {

    /*
     * tenantId() {
     *   if (this.tenantId) {
     *     this.getMenuTree(this.tenantId);
     *   }
     * },
     */
  },

  mounted() {
    this.getMenuTree(this.tenantId);
  },
  methods: {
    // 获取web端菜单tree
    getMenuTree(id) {
      this.loading = true;
      const parmas = {
        parseToTree: true
      };
      BusinessApi.getMenuByTenantId(id, parmas)
        .then(res => {
          this.loading = false;
          let hasWeb = false;
          let hasApp = false;
          const tempArray = JSON.parse(JSON.stringify(res.data));
          for (let index = 0; index < tempArray.length; index++) {
            const item = tempArray[index];
            if (item.authorized) {
              if (item.clientType === "APP") {
                hasApp = true;
              }

              if (item.clientType === "WEB") {
                hasWeb = true;
              }
            }
          }

          const selectIds = this.collectIds(tempArray);

          hasWeb && selectIds.push(-1);
          hasApp && selectIds.push(-2);
          this.defaultCheckedKeys = selectIds;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    collectIds(nodeList, list = []) {
      for (let i = 0; i < nodeList.length; i++) {
        const node = nodeList[i];
        if (node.authorized) {
          list.push(node.id);
        }

        if (Array.isArray(node.children)) {
          this.collectIds(node.children, list);
        }
      }

      return list;
    },

    // 获取web端菜单tree
    // getMenuTree(id) {
    //   this.loading = true;
    //   const parmas = {
    //     parseToTree: true,
    //   };
    //   BusinessApi.getMenuByTenantId(id, parmas)
    //     .then((res) => {
    //       this.loading = false;
    //       this.webMenuTree = this.handleData(res.data || [], 1);
    //       this.defaultCheckedKeys = this.getChildIds(res.data || []);
    //     })
    //     .catch(() => {
    //       this.loading = false;
    //     });
    // },
    // // 递归寻找子节点
    // getChildIds(arr) {
    //   const result = [];
    //   const digui = (arr) => {
    //     for (let i = 0; i < arr.length; i++) {
    //       const o = arr[i];
    //       if (o.children && o.children.length) {
    //         digui(o.children);
    //       } else {
    //         if (o.authorized) {
    //           result.push(o.id);
    //         }
    //       }
    //     }
    //   };
    //   digui(arr);
    //   return result;
    // },
    // // 格式化菜单tree
    // handleData(data, level) {
    //   return data.map((o) => {
    //     this.nodeCount++;
    //     let _level = level;
    //     const obj = {
    //       level: _level,
    //       label: o.menuName,
    //       id: o.id,
    //     };
    //     if (o.children && o.children.length) {
    //       obj.children = this.handleData(o.children, ++_level);
    //     } else {
    //       this.childCount++;
    //     }
    //     return obj;
    //   });
    // },

    /**
     * @description: 确定
     * @param {*}
     * @return {*}
     */
    handleConfirm() {
      const menuIds = this.$refs.webTree.getCheckedKeys();
      const menuIds2 = this.$refs.webTree.getHalfCheckedKeys();

      const appMenuIds = this.$refs.appTree.getCheckedKeys();
      const appMenuIds2 = this.$refs.appTree.getHalfCheckedKeys();

      const params = [...menuIds, ...menuIds2, ...appMenuIds, ...appMenuIds2];
      this.loading = true;
      BusinessApi.saveCustomRole(this.tenantId, params)
        .then(res => {
          this.loading = false;
          this.$message.closeAll();
          this.$message.success("操作成功");
          this.$emit("success", true);
          this.dialogVisible = false;
        })
        .catch(() => {
          this.loading = false;
          this.$message.closeAll();
          this.$message.error("操作失败");
        });
    },

    /**
     * @description: web、app切换
     * @param {*} tab
     * @param {*} event
     * @return {*}
     */
    handleTabClick(tab, event) {
      /*
       * const checkChange = this.$refs.webTree.getCheckChange();
       * console.log(checkChange);
       */
      this.activeTabName = tab.name;
    }
  }
};
</script>

<style lang="scss">
// .custom-theme .self-dialog-form .el-dialog__body{
//   overflow-y: hidden!important;;
// }
</style>
